module.exports = __webpack_public_path__ + "img/jianjietopmin.a1111c5b.png";